import {
  SCOPE_LABEL,
  type SkillScope,
} from '#src/components/ai-elements/Skill/types.ts'
import { Badge } from '#src/components/Badge/Badge.tsx'

export function SkillScopeBadge({ scope }: { scope: SkillScope }) {
  return (
    <Badge variant="outline" color={scope === 'shared' ? 'blue' : 'gray'}>
      {SCOPE_LABEL[scope]}
    </Badge>
  )
}
